import React from 'react'
import { Outlet, Navigate } from 'react-router-dom'
import { isAuthenticated } from 'helpers'

export const ProtectedRoutes = () => {
    const authenticated = isAuthenticated()

    return authenticated ? <Outlet /> : <Navigate to="/login" />
}
